import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import LeaveToggleSwitch from "../../../features/leave/components/leaveSwitch/LeaveSwitch";

interface RHFToggleSwitchProps {
  name: string;
  label?: string;
  disabled?: boolean;
  /** Label pair e.g. ["Full Day", "Custom"] or ["Yes", "No"] */
  toggleLabels?: [string, string];
}

/**
 * RHFToggleSwitch
 * A reusable React Hook Form–compatible toggle field.
 * Works with either text values (e.g. "Full Day"/"Custom") or boolean toggles.
 */
const RHFToggleSwitch: React.FC<RHFToggleSwitchProps> = ({
  name,
  label,
  disabled = false,
  toggleLabels = ["Yes", "No"],
}) => {
  const { control, setValue } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const [onLabel, offLabel] = toggleLabels;
        const currentValue =
          field.value === undefined
            ? onLabel // default state
            : field.value;
        const handleToggle = () => {
          if (disabled) return;
          const next = currentValue === onLabel ? offLabel : onLabel;
          setValue(name, next);
        };

        return (
          <div className="form-group">
            {label && <label className="form-label">{label}</label>}

            {/* Use existing switch UI */}
            <LeaveToggleSwitch
              isFullDay={currentValue}
              handleToggle={handleToggle}
            />

            {fieldState.error?.message && (
              <div className="text-danger small mt-1">
                {fieldState.error.message}
              </div>
            )}
          </div>
        );
      }}
    />
  );
};

export default RHFToggleSwitch;
